import { Box, Typography } from "@mui/material"

const EDIT_WARNING_MESSAGE = "Before creating the job, please edit the details or cancel them."

export default function EditWarningMessage() {
    return <Box style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "auto", borderRadius: "0.5em", gap: "1em", marginTop: "0.5em" }} >
        <Typography flexGrow={0} color={"orange"}>{EDIT_WARNING_MESSAGE}</Typography>
    </Box>
}